var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMicroscope = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 564,
    height: 564,
    viewBox: "0 0 564 564",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1423_195495)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.289 195.212C309.128 158.757 338.389 68.8777 404.573 73.934C470.883 78.9999 496.616 157.945 524.307 215.993C549.014 267.787 570.063 324.668 550.809 380.486C532.277 434.212 480.169 468.225 428.286 494.359C380.62 518.369 329.648 521.292 277.214 518.3C208.296 514.367 124.757 527.947 84.5083 474.74C43.1039 420.005 55.7878 335.239 92.4861 274.098C123.893 221.773 200.296 228.558 252.289 195.212Z",
    fill: "#F4F6F5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1423_195495)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1423_195495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.816 351.061H141.791V360.661H178.816V351.061Z",
    fill: "#C84A17"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.304,
    cy: 351.061,
    rx: 18.5127,
    ry: 2.74286,
    fill: "#FFE2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.184 351.061H191.158V360.661H228.184V351.061Z",
    fill: "#C84A17"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.671,
    cy: 351.061,
    rx: 18.5127,
    ry: 2.74286,
    fill: "#FFE2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.551 339.062H240.525V360.661H277.551V339.062Z",
    fill: "#C84A17"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.038,
    cy: 339.063,
    rx: 18.5127,
    ry: 6.17089,
    fill: "#FFE2D7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 250.167,
    cy: 338.293,
    rx: 3.85681,
    ry: 0.771361,
    fill: "#FFC143"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.423,
    cy: 341.377,
    rx: 3.85681,
    ry: 0.771361,
    fill: "#1EC04A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M270.995 338.293C270.995 338.719 269.268 339.064 267.138 339.064C265.008 339.064 263.281 338.719 263.281 338.293C263.281 337.867 265.008 337.521 267.138 337.521C269.268 337.521 270.995 337.867 270.995 338.293Z",
    fill: "#E11903"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.918 351.061H289.893V360.661H326.918V351.061Z",
    fill: "#C84A17"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.405,
    cy: 351.061,
    rx: 18.5127,
    ry: 2.74286,
    fill: "#FFE2D7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.826 359.559H165.676V368.019H327.826V359.559Z",
    fill: "#BFD6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.313 367.684H350.41V337.689H343.313V367.684Z",
    fill: "#BFD6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.873 346.838H358.855V335.419H334.873V346.838Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.257 335.43H335.66V346.849H337.257V335.43Z",
    fill: "#ECF3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.441 335.43H338.844V346.849H340.441V335.43Z",
    fill: "#ECF3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.628 335.43H342.031V346.849H343.628V335.43Z",
    fill: "#ECF3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.812 335.43H345.215V346.849H346.812V335.43Z",
    fill: "#ECF3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.999 335.43H348.402V346.849H349.999V335.43Z",
    fill: "#ECF3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.187 335.43H351.59V346.849H353.187V335.43Z",
    fill: "#ECF3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.371 335.43H354.773V346.849H356.371V335.43Z",
    fill: "#ECF3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.446 129.383H239.363V272.054H284.446V129.383Z",
    fill: "#BFD6D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M255.562 129.383H247.07V272.651H255.562V129.383Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M268.136 129.383H259.645V272.651H268.136V129.383Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.311 450.484L409.852 437.799V488.716H139.086C139.086 468.377 154.992 451.582 175.311 450.484Z",
    fill: "#002925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.531 488.729H409.863V466.047L175.312 478.721C166.13 479.223 157.848 482.936 151.531 488.729Z",
    fill: "#BFD6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.599 439.443C379.599 439.443 412.697 420.745 419.431 393.304C426.166 365.864 452.048 207.579 325.722 174.115V226.361C325.722 226.361 374.433 234.455 375.96 285.404C377.486 336.353 363.254 364.661 336.075 376.656C308.896 388.651 291.505 417.911 294.37 444.044L379.599 439.443Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.827 367.182H165.27V372.975H350.827V367.182Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.383 372.973C212.383 375.43 212.383 390.363 212.383 390.363C212.383 390.363 276.393 383.19 298.919 424.695L350.83 372.973H212.383Z",
    fill: "#BFD6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.193 383.303H230.672V422.037H284.193V383.303Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.501 414.916H233.789V429.64H277.501V414.916Z",
    fill: "#002925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.044 89.8906H248.023V129.378H272.044V89.8906Z",
    fill: "#002925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.778 75.3086H235.293V89.8968H284.778V75.3086Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.321 163.15H284.445V237.399H327.321V163.15Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.496 208.211C341.099 201.607 341.099 190.901 334.496 184.297C327.892 177.693 317.186 177.693 310.582 184.297C303.978 190.901 303.978 201.607 310.582 208.211C317.186 214.814 327.892 214.814 334.496 208.211Z",
    fill: "#002925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.348 203.497C334.35 199.182 334.098 192.44 329.783 188.438C325.469 184.435 318.726 184.688 314.724 189.002C310.721 193.317 310.974 200.059 315.289 204.062C319.603 208.064 326.345 207.811 330.348 203.497Z",
    fill: "#BFD6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.596 424.927C380.927 424.927 390.923 414.931 390.923 402.6C390.923 390.269 380.927 380.273 368.596 380.273C356.266 380.273 346.27 390.269 346.27 402.6C346.27 414.931 356.266 424.927 368.596 424.927Z",
    fill: "#002925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.597 416.66C376.365 416.66 382.662 410.363 382.662 402.595C382.662 394.827 376.365 388.529 368.597 388.529C360.829 388.529 354.531 394.827 354.531 402.595C354.531 410.363 360.829 416.66 368.597 416.66Z",
    fill: "#BFD6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.348 247.454L238.133 235.789L200.413 288.222L216.628 299.886L254.348 247.454Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.155 298.816L202.777 289.912L198.692 295.592L211.069 304.496L215.155 298.816Z",
    fill: "#002925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.724 247.812H245.75V309.878H265.724V247.812Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.868 309.869H247.621V316.865H262.868V309.869Z",
    fill: "#002925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.226 247.812H255.016V282.469H274.226V247.812Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.226 257.037H245.75V259.254H274.226V257.037Z",
    fill: "#002925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.226 262.516H245.75V264.733H274.226V262.516Z",
    fill: "#002925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.125 248.19L269.387 237.211L303.503 284.634L288.241 295.614L254.125 248.19Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.627 294.604L301.277 286.223L305.123 291.568L293.473 299.949L289.627 294.604Z",
    fill: "#002925"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M207.059 359.754H203.922V370.211H207.059V359.754Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M214.379 359.754H211.242V370.211H214.379V359.754Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M274.238 372.57H270.965V405.334H274.238V372.57Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M281.035 372.57H277.762V405.334H281.035V372.57Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M343.352 469.986H336.973V488.726H343.352V469.986Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M328.012 469.986H321.633V488.726H328.012V469.986Z",
    fill: "#0F4A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.024 205.283L206.785 221.285L297.356 273.578L306.595 257.576L216.024 205.283Z",
    fill: "#002925"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1423_195495)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M240.031 339.673L247.62 316.219H262.796L277.973 339.026C277.283 343.812 252.724 351.647 240.031 339.673Z",
    fill: "url(#paint0_linear_1423_195495)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1423_195495",
    x1: 259.002,
    y1: 316.219,
    x2: 259.002,
    y2: 346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F6FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1423_195495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 564,
    height: 564,
    rx: 282,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1423_195495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 287.121,
    height: 413.416,
    fill: "white",
    transform: "translate(139.086 75.2852)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1423_195495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161.986,
    height: 41.6535,
    fill: "white",
    transform: "translate(164.918 318.66)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1423_195495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.9414,
    height: 29.7812,
    fill: "white",
    transform: "translate(240.031 316.219)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMicroscope, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Microscope.6722ecc7.svg";
export { ForwardRef as ReactComponent };